import cityinfoIndex from '@/pages/cityinfo/index.vue'
import cityinfoList from '@/pages/cityinfo/cityinfoList.vue'
import cityinfoClass from '@/pages/cityinfo/cityinfoClass.vue'
import cityinfoDetail from '@/pages/cityinfo/cityinfoDetail.vue'

const appRoutes = [{
	path: '/cityinfo',
	redirect: '/cityinfo/cityinfoList',
	component: cityinfoIndex,
	children: [{
		path: 'cityinfoList',
    name: 'cityinfoList',
		component: cityinfoList
	},{
		path: 'cityinfoClass',
    name: 'cityinfoClass',
		component: cityinfoClass
	},{
		path: 'cityinfoDetail',
    name: 'cityinfoDetail',
		component: cityinfoDetail
	}]
}]
export default appRoutes
